import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { SeatsioSeatingChart } from '@seatsio/seatsio-react';
import { Card } from '@opendate-app/setlist';
import {
  inventoryObjectColor,
  inventoryObjectIcon,
} from '../../../shared/seatsioUtils';

export const HoldsKillsChartView = ({ selectedEvent, holds, kills, seatsIOPublicKey }) => {
  const seatsioEventId = selectedEvent && selectedEvent.seatsio_event_id;

  const labelToHoldConfig = useMemo(() => (
    (holds || []).reduce((memo, hold) => {
      (hold.objects || []).forEach((label) => {
        if (label) {
          memo[label] = { name: hold.name, color: hold.color };
        }
      });
      return memo;
    }, {})
  ), [holds]);

  const labelToKillConfig = useMemo(() => (
    (kills || []).reduce((memo, kill) => {
      (kill.objects || []).forEach((label) => {
        if (label) {
          memo[label] = { name: kill.name };
        }
      });
      return memo;
    }, {})
  ), [kills]);

  const channels = useMemo(() => (
    [
      ...(holds || []).map((h) => h.seatsio_channel_key).filter(Boolean),
      'NO_CHANNEL',
    ]
  ), [holds]);

  if (!seatsioEventId || !seatsIOPublicKey) {
    return null;
  }

  return (
    <div className="mt-3">
      <Card padding="none">
        <div style={{ height: '515px' }}>
          <SeatsioSeatingChart
            workspaceKey={seatsIOPublicKey}
            event={seatsioEventId}
            fitTo="widthAndHeight"
            channels={channels}
            extraConfig={{ labelToHoldConfig, labelToKillConfig }}
            objectColor={inventoryObjectColor}
            objectIcon={inventoryObjectIcon}
            region="na"
          />
        </div>
      </Card>
    </div>
  );
};

HoldsKillsChartView.propTypes = {
  selectedEvent: PropTypes.object,
  holds: PropTypes.array,
  kills: PropTypes.array,
  seatsIOPublicKey: PropTypes.string,
};

HoldsKillsChartView.defaultProps = {
  selectedEvent: null,
  holds: [],
  kills: [],
  seatsIOPublicKey: '',
};
